import { getLocaleKeyFromLocaleString } from "@faire/retailer-visitor-shared/consts/LANGUAGE";
import { COOKIE_LOCALE_OVERRIDE } from "@faire/web--source/common/consts/COOKIE_LOCALE_OVERRIDE";
import { getCookies } from "@faire/web--source/common/cookies";
import { getLocationOrThrow } from "@faire/web--source/common/globals/getLocation";
import { localizePath } from "@faire/web--source/ui/routing/util";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";

export const assignWithLocale = (path: string) => {
  //This cookie may be set in handleCreateUser()
  const language = getCookies(COOKIE_LOCALE_OVERRIDE);

  if (language === undefined) {
    getLocationOrThrow().assign(path);
  } else if (language in Language) {
    getLocationOrThrow().assign(
      localizePath(path, Language[language as keyof typeof Language])
    );
  } else {
    // the locale cookie is in format fr-FR
    const localeKey = getLocaleKeyFromLocaleString(language);
    getLocationOrThrow().assign(
      localizePath(path, Language[localeKey.language!], localeKey)
    );
  }
};
